import { lookup } from '../content';
import { SPECIALS } from '../specials';
import { applyDerivedStats } from '../stats';
import type { StepContext } from './types';

export function specials(ctx: StepContext): void {
  const { state, content } = ctx;
  for (const player of state.players) {
    const timedSlow =
      player.slowFactorExpiresTick !== undefined && player.slowFactorExpiresTick > state.tick
        ? (player.slowFactorValue ?? 1)
        : undefined;
    if (timedSlow !== undefined) {
      player.slowFactor = timedSlow;
    } else if (player.slowFactor !== undefined) {
      player.slowFactor = 1;
    }
    if (player.suppressedTicks !== undefined && player.suppressedTicks > 0) {
      player.suppressedTicks -= 1;
      if (player.suppressedTicks === 0) {
        applyDerivedStats(player, lookup(content.classes, player.classId, 'class'));
      }
    }
    if (player.dazzledTicks !== undefined) {
      player.dazzledTicks = Math.max(0, player.dazzledTicks - 1);
    }
    if (player.sunTicks !== undefined) {
      player.sunTicks = Math.max(0, player.sunTicks - 1);
    }
  }
  for (const enemy of state.enemies) {
    if (enemy.hp <= 0) {
      continue;
    }
    const special = lookup(content.enemies, enemy.kind, 'enemy').special;
    if (special !== undefined) {
      SPECIALS[special.kind](ctx, enemy, special);
    }
  }
  for (const player of state.players) {
    const { slowMul } = lookup(content.classes, player.classId, 'class');
    if (slowMul !== undefined && player.slowFactor !== undefined) {
      player.slowFactor = 1 - (1 - player.slowFactor) * slowMul;
    }
  }
}
